"use client"

import React, { createContext, useContext } from 'react'

interface LoginFormPrefills {
    prefilledRegion?: number
    prefilledRole?: 'homeowner' | 'volunteer'
    prefilledTeam?: string
}

const LoginFormContext = createContext<LoginFormPrefills>({})

export function LoginFormContextProvider({
    children,
    value,
}: {
    children: React.ReactNode
    value: LoginFormPrefills
}) {
    return (
        <LoginFormContext.Provider value={value}>
            {children}
        </LoginFormContext.Provider>
    )
}

export function useLoginFormPrefills() {
    return useContext(LoginFormContext)
}
